import { ExtractPropTypes, PropType } from 'vue'

export const checkboxProps = {
  modelValue: [Number, String, Boolean] as PropType<number | string | boolean>,
  indeterminte: Boolean,
  disabled: Boolean,
  label: {
    type: String as PropType<string>
  }
} as const

export type CheckboxProps = Partial<ExtractPropTypes<typeof checkboxProps>>

export const checkboxEmits = {
  'update:modelValue': (value: boolean | string | number) => typeof value === 'boolean',
  change: (value: boolean) => typeof value === 'boolean'
}

export type CheckboxEmits = typeof checkboxEmits
